import { Modal as AntdModal, type ModalProps } from 'antd';
import type { FC } from 'react';

export const Modal: FC<ModalProps> = (props) => {
  return (
    <AntdModal
      {...props}
      cancelButtonProps={{ ...props.cancelButtonProps, autoInsertSpace: false }}
      okButtonProps={{ ...props.okButtonProps, autoInsertSpace: false }}
      data-dd-privacy="allow"
    >
      {props.children}
    </AntdModal>
  );
};
